import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Updateeditform(state = initialState, action) {
  
  switch (action.type) {
    case userConstants.UPDATEEDITFORM_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.UPDATEEDITFORM_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.UPDATEEDITFORM_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}